var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": _vm.hasCandidateOtherJob, label: "送信候補" } },
    [
      _c("label", { staticClass: "boss-checkbox" }, [
        _c("input", {
          staticClass: "boss-input-checkbox",
          attrs: { type: "checkbox", "data-test": "candidate-other-job" },
          domProps: { checked: _vm.hasCandidateOtherJob },
          on: {
            change: function ($event) {
              return _vm.$emit(
                "update:hasCandidateOtherJob",
                $event.target.checked
              )
            },
          },
        }),
        _vm._v("その他の自社求人で送信候補に入れている会員を除外\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-annotation-text" }, [
        _vm._v(
          "\n    ※この自社求人で送信候補に入れている会員はすでに除外されています。\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }